import ValidationOrdersDropzone from './component';

export default ValidationOrdersDropzone;
